@if (_active) {
  <kendo-window
    [class.editFieldsModeClass]="_pageState == 4"
    title="{{ _pageState == 2 ? 'ADD NEW RECORD BUILDING' : _pageState == 3 ? 'EDIT RECORD' : _pageState == 1 ? 'VIEW RECORD' : _pageState == 4 ? 'EDIT FIELDS MODE' : '' }}"
    (close)="_closeForm()"
    (stateChange)="_onStateChanges($event)"
    class="fullWidthFormForm"
    [class.disabledPopup]="_editFormActive || _orderingTabsForm || _deactivatedFieldsForm"
    (keydown.enter)="$event.preventDefault()"
    #mainWindow>
    <!-- Form -->
    <form novalidate [formGroup]="_formGroup" class="form_style">
      <div class="row special_row_margin">
        <div class="col-6 special_col_padding"
          [class.col-12]="_pageState == 2 || _pageState == 4 ||  _pageState == 3">
          <div class="border_sections margin-top-4 bordered-With-charts">
            <div class="row">
              <div class="col-12">
                <h2 class="formsTitle">
                  Building
                  @if (canAccess('customers', 'update')) {
                    <span (click)="_edit()"
                      [class.ViewModeVisibleElement]="_pageState == 1"
                      class="action-button action-button-viewMode">
                      <div class="action-button-icon">
                        <img src="/assets/menu/enterprise/edit-action-icon-grid.svg" />
                      </div>
                      <div class="edit-icon-text">Edit</div>
                    </span>
                  }
                </h2>
                <div class="upsert-header-buttons">
                  <ul class="menuButtonsList">
                    <!-- <li
                    (click)="_onEditForms()"
                    *ngIf="canAccess('customers', 'update') && this._currentUser.appRole.id!=3 && this._currentUser.appRole.id!=4"
                    [class.ViewModelHiddenElement]="_pageState != 2"
                    >
                    Edit Forms
                  </li>
                  <li
                    class="wikiButton"
                    (click)="_onEditFields()"
                    *ngIf=" this._currentUser.appRole.id!=3 && this._currentUser.appRole.id!=4 "
                    [class.ViewModeHiddenElement]="_pageState != 2"
                    >
                    Edit Fields
                  </li>
                  <li
                    class="wikiButton"
                    (click)="_returnAdNew()"
                    [class.ViewModeHiddenElement]="_pageState != 4"
                    >
                    Close Edit Fields
                  </li>
                  <li
                    *ngIf="_pageState == 2 || _pageState == 3"
                    class="wikiButton"
                    [class.disabled]="_deactivatedFieldsGridData?.length == 0"
                    (click)="_viewInactiveFields()"
                    >
                    View Inactive Fields
                  </li> -->
                </ul>
                @if (_pageState != 1) {
                  <div>
                    <button kendoButton
                      class="steps_buttons_class"
                      (click)="_onCancel()">
                      <img class="backimage"
                        [src]="'/assets/menu/'+ _theme +'/close-schedule-report-icon-green.svg'" />
                        <span>close</span>
                      </button>
                      @if (canAccess('building', 'create')) {
                        <button
                          kendoButton
                          class="steps_buttons_class"
                          [disabled]="_pageState == 4 ? true : false"
                          (click)="_onSave('saveAndCopy')">
                          <img class="backimage"
                            [src]="'/assets/menu/'+ _theme +'/save-icon-group.svg'" />
                            <span>save & Copy</span>
                          </button>
                        }
                        @if (canAccess('building', 'create')) {
                          <button
                            kendoButton
                            class="steps_buttons_class"
                            [disabled]="_pageState == 4 ? true : false"
                            (click)="_onSave('saveAndNew')">
                            <img class="backimage"
                              [src]="'/assets/menu/'+ _theme +'/save-icon-group.svg'" />
                              <span>save & New</span>
                            </button>
                          }
                          <button kendoButton
                            class="steps_buttons_class"
                            [disabled]="_pageState == 4 ? true : false"
                            (click)="_onSave('saveAndClose')">
                            <img class="backimage"
                              [src]="'/assets/menu/'+ _theme +'/save-icon-group.svg'" />
                              <span>save & Close</span>
                            </button>
                            <button kendoButton
                              class="steps_buttons_class"
                              [disabled]="_pageState == 4 ? true : false"
                              (click)="_onSave('save')">
                              <img class="backimage"
                                [src]="'/assets/menu/'+ _theme +'/save-icon-group.svg'" />
                                <span>save</span>
                              </button>
                            </div>
                          }
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="formsMenuSeparator"></div>
                      </div>
                    </div>
                    <div class="row row_padding">
                      <fieldset class="col-12" [class.col-6-imp]="_pageState == 2 || _pageState == 4 || _pageState == 3">
                        <!--All Sites DropDown-->
                        <sites-dropdown #kendo_combo_SiteCode
                          [(ngModel)]="_siteSelected"
                          (siteChanged)="_handleSitesChange($event)"
                          [ngModelOptions]="{standalone: true}"
                          [textField]="'code'"
                          [valueField]="'id'"
                          [inputClass]="'MultiSiteCustomComboBox k-combobox bordered newFormControlWidth'"
                          [layout]="'form-group'"
                          [labelText]="'Site Code'">
                        </sites-dropdown>
                        <ng-container>
                          <!--------------- ADDRESS---------------------------------->
                          @if (getAuthByLabel('LBL_FacilityDesc')?.canView) {
                            <div KendoToolTip
                              class="form-group special_style_formgroup">
                              <label for="contactperson" class="control-label">
                                Address
                              </label>
                              <kendo-multicolumncombobox #listaddress
                                [data]="getAddressesFiltered"
                                [listHeight]="300"
                                class="required-input current-step k-combobox bordered newFormControlWidth k-combobox newFormControlWidth"
                                [class.ViewModeDisabledControl]="_pageState == 1"
                                [filterable]="true"
                                (filterChange)="_handleAddressFilter($event)"
                                [suggest]="true"
                                [placeholder]="'Choose an Address'"
                                formControlName="addressid"
                                [textField]="'name'"
                                [valueField]="'id'"
                                [disabled]="_pageState==1"
                                [attr.disabled]="getAuthByLabel('LBL_LocHomeLoc')?.canEdit ? null : 'disabled'"
                                [attr.required]="getLabel('LBL_LocHomeLoc')?.isRequired ? 'required' : null"
                                required>
                                <kendo-combobox-column field="name"
                                  title="Address Name"
                                  [width]="200">
                                </kendo-combobox-column>
                                <kendo-combobox-column field="addressLine1"
                                  title="Address 1"
                                  [width]="200">
                                </kendo-combobox-column>
                                <kendo-combobox-column field="addressLine2"
                                  title="Address 2"
                                  [width]="200">
                                </kendo-combobox-column>
                                <kendo-combobox-column field="city"
                                  title="City"
                                  [width]="200">
                                </kendo-combobox-column>
                                <kendo-combobox-column field="state"
                                  title="State"
                                  [width]="200">
                                </kendo-combobox-column>
                                <kendo-combobox-column field="zip"
                                  title="zip"
                                  [width]="200">
                                </kendo-combobox-column>
                                <kendo-combobox-column field="country"
                                  title="Country"
                                  [width]="200">
                                </kendo-combobox-column>
                                <ng-template kendoMultiColumnComboBoxFooterTemplate>
                                  <strong> {{getAddresses.length}} records in total </strong>
                                </ng-template>
                              </kendo-multicolumncombobox>
                              @if (canAccess('addresses', 'create')) {
                                <a
                                  [class.disabled]="_pageState == 1"
                                  class="cursor-pointer"
                                  (click)="_openForm('addresses','building-location')">
                                  <img class="searchIcon"
                                    [src]="'/assets/menu/'+ _theme +'/add-new-icon_grid.svg'" />
                                  </a>
                                }
                              </div>
                            }
                            <!---------------END ADDRESS---------------------------------->
                            @if (getAuthByLabel('LBL_FacilityDesc')?.canView) {
                              <div KendoToolTip
                                class="form-group special_style_formgroup">
                                <label for="description" class="control-label">Building</label>
                                <input #BuildingDescription
                                  [class.ViewModeDisabledControl]="_pageState == 1"
                                  type="text"
                                  class="k-textbox writebox min-width-0 newFormControlWidth"
                                  formControlName="description"
                                  placeholder="Building"
                                  [readonly]="_pageState == 1"
                                  [disabled]="_pageState==1"
                                  [attr.disabled]="getAuthByLabel('LBL_LocTypeDesc')?.canEdit ? null : 'disabled'"
                                  [attr.required]="getLabel('LBL_LocTypeDesc')?.isRequired ? 'required' : null"
                                  required />
                                  <!--------------- Building Image---------------------------------->
                                  @if (getAuthByLabel('LBL_FacilityDesc')?.canView) {
                                    <div KendoToolTip
                                      class="form-group special_style_formgroup">
                                      <label for="contactperson" class="control-label">
                                        Building Image
                                      </label>
                                      <kendo-multicolumncombobox #fileslist
                                        [data]="getpicturefiles"
                                        [listHeight]="300"
                                        class="required-input current-step k-combobox bordered newFormControlWidth k-combobox newFormControlWidth"
                                        [class.ViewModeDisabledControl]="_pageState == 1"
                                        [filterable]="true"
                                        (filterChange)="_handleAddressesFilter($event)"
                                        [suggest]="true"
                                        [placeholder]="'Choose a Building Image'"
                                        formControlName="fileid"
                                        [textField]="'name'"
                                        [valueField]="'id'"
                                        [disabled]="_pageState==1"
                                        [attr.disabled]="getAuthByLabel('LBL_LocHomeLoc')?.canEdit ? null : 'disabled'"
                                        [attr.required]="getLabel('LBL_LocTypeDesc')?.isRequired ? 'required' : null"
                                        required>
                                        <kendo-combobox-column field="thumbnail"
                                          title="Image"
                                          [width]="140">
                                        </kendo-combobox-column>
                                        <kendo-combobox-column field="name"
                                          title="Image Name"
                                          [width]="200">
                                        </kendo-combobox-column>
                                        <kendo-combobox-column field="description"
                                          title="Image Description"
                                          [width]="200">
                                        </kendo-combobox-column>
                                        <ng-template kendoMultiColumnComboBoxFooterTemplate>
                                          <strong> {{getpicturefiles.length}} records in total </strong>
                                        </ng-template>
                                      </kendo-multicolumncombobox>
                                      @if (canAccess('files', 'create')) {
                                        <a
                                          [class.disabled]="_pageState == 1"
                                          class="cursor-pointer"
                                          (click)="_openForm('files','building-location')">
                                          <img class="searchIcon"
                                            [src]="'/assets/menu/'+ _theme +'/add-new-icon_grid.svg'" />
                                          </a>
                                        }
                                      </div>
                                    }
                                    <!---------------END Building Image---------------------------------->
                                  </div>
                                }
                              </ng-container>
                            </fieldset>
                          </div>
                        </div>
                      </div>
                      @if (_pageState != 2 && _pageState != 4) {
                        <div class="col-6 special_col_padding"
                          >
                          <!-- <div class="border_sections margin-top-4 bordered-With-charts">
                          <div
                            class="col-12 charts-container upsert-donut-chart"
                            *ngIf="(_currentUser && _currentUser.isEnterprise)"
                            >
                            <ng-container *ngFor="let chart of _donutChartSmall">
                              <div
                                class="donut-component-single-container"
                                (click)="_openCirclesForm()"
                                >
                                <asap-donut-chart
                                  class=""
                                  [model]="chart"
                                  [chartTooltip]="_tooltipVisibilityUpsert"
                                  >
                                </asap-donut-chart>
                                <div class="dont-chart-title">{{chart.title}}</div>
                              </div>
                            </ng-container>
                          </div>
                          <div
                            class="col-12 appliance-Sharts-Container"
                            *ngIf="(_currentUser && !_currentUser.isEnterprise)"
                            >
                            <div class="tabsSection">
                              <ul class="tabsectionList"></ul>
                            </div>
                            <div
                              (click)="OnOpenStockItemForm($event)"
                              *ngIf="_NOSActive && buildingChart && _stockItemGridColumns"
                              class="stock-item-chart"
                              >
                              <apx-chart
                                [title]="buildingChart.title"
                                [series]="buildingChart.series"
                                [chart]="buildingChart.chart"
                                [xaxis]="buildingChart.xaxis"
                                [stroke]="buildingChart.stroke"
                                [dataLabels]="buildingChart.dataLabels"
                              ></apx-chart>
                            </div>
                          </div>
                        </div> -->
                      </div>
                    }
                  </div>
                  <!-- <div class="example-wrapper">
                  <div class="row no_row_margin">
                    <div
                      class="col-8 col-lg-8 col-xl-8 responsive_style numericboxtab"
                      #kendo_tabstrip_wrapper
                      >
                      <kendo-tabstrip
                        [tabPosition]="_kendoTabStripPosition"
                        (tabSelect)="_onTabSelect($event)"
                        *ngIf="_hasCustomTabs()"
                        >
                        <ng-container *ngFor="let tab of _dataTabs">
                          <kendo-tabstrip-tab *ngIf="tab.isCustom " [title]="tab.name">
                            <ng-template kendoTabContent>
                              <div class="tabcontent">
                                <fieldset class="contenttabstyle margin-top-10">
                                  <asap-custom-fields-form
                                    [customFields]="_customFields[tab.id]"
                                    [pageState]="_pageState"
                                    [accounts]="_selectedAccountIds"
                                    [formName]="'stock'"
                                    page="building"
                                    [invalidSubmit]="_invalidSubmit"
                                    (customFieldsValue)="_customFieldsValueChanges($event, tab.id)"
                                    (customFieldsDeleteValue)="_removeCustomField($event)"
                                    (customFieldsEditValue)="_openCustomRenameForm($event, tab.id)"
                                    (customFieldsStatus)="formStatus($event)"
                                    [_customFieldsValue]="_customFieldsValue"
                                    >
                                  </asap-custom-fields-form>
                                  <div class="form-group special_style_formgroup">
                                    <button
                                      kendobutton
                                      class="addNewFieldButton k-button"
                                      (click)="_addNewField(tab.id)"
                                      >
                                      <img
                                        class="backimage"
                                        src="/assets/menu/enterprise/add-icon-green.svg"
                                        /><span>Add New Field</span>
                                      </button>
                                    </div>
                                    <div class="form-group special_style_formgroup">
                                      <button
                                        kendobutton
                                        class="addNewFieldButton k-button"
                                        (click)="_deactivateTab(tab.id, 'stockItems')"
                                        >
                                        <img
                                          class="backimage"
                                          src="/assets/menu/enterprise/add-icon-green.svg"
                                          /><span>Deactivate Tab</span>
                                        </button>
                                      </div>
                                    </fieldset>
                                  </div>
                                </ng-template>
                              </kendo-tabstrip-tab>
                            </ng-container>
                          </kendo-tabstrip>
                        </div>
                      </div>
                    </div> -->
                    <div class="row no_row_margin">
                      <div class="col-12">
                        <button kendobutton
                          class="addNewtabButton k-button"
                          (click)="_addNewTab()">
                          <img class="backimage"
                            src="/assets/menu/enterprise/add-icon-green.svg" /><span>Add New Tab</span>
                          </button>
                        </div>
                      </div>
                      <div class="row no_row_margin">
                        <div class="col-12">
                          <button kendobutton
                            class="reorderTabButton k-button"
                            (click)="_reorderingtabs()">
                            <img class="backimage"
                              src="/assets/menu/enterprise/reorder-tabs-icon.svg" /><span>reorder tabs</span>
                            </button>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-12">
                            @if (_invalidForm) {
                              <asap-forms-validation-summary
                                [form]="_formGroup"
                                [page]="'building'"
                                [customValidation]="_customValidation"
                                [additionalErrors]="_additionalErrors">
                              </asap-forms-validation-summary>
                            }
                          </div>
                        </div>
                      </form>
                      @if (CheckIfWeAreInEditMode()) {
                        <div class="asap-footer">
                          <ul class="asap-footer-content-list">
                            <li>
                              <span class="label-footer">Date Added:</span>{{
                              _model.createdOn |
                              dateFormat
                              }}<span class="separator">.</span><span class="label-footer">Added By User:</span>{{
                              _model.createdUser?
                              _model.createdUser.userName : null
                              }}
                            </li>
                            <li>
                              <span class="label-footer">Last Edited:</span>{{
                              _model.lastUpdatedOn |
                              dateFormat
                              }}<span class="separator">.</span><span class="label-footer">Last Edited By User:</span>{{_model.updatedUser? _model.updatedUser.userName : null}}
                            </li>
                          </ul>
                        </div>
                      }
                      @if (_isDialiog) {
                        <asap-dialog-layout
                          [data]="_dialogModel"
                          [componentName]="_dialogComponentName"
                          (closeDialog)="_closeDialog($event)">
                        </asap-dialog-layout>
                      }
                    </kendo-window>
                  }
                  @if (_showCirclesForm) {
                    <kendo-window
                      title="Building Per Account"
                      (keydown.enter)="$event.preventDefault()"
                      (close)="_closeCirclesForm()">
                      <div class="col-12 donut-form-container">
                        @for (chart of _donutChartLarge; track chart) {
                          <div class="donut-component-single-container">
                            <asap-donut-chart class=""
                              [model]="chart"
                              [chartTooltip]="_tooltipVisibilityForm">
                            </asap-donut-chart>
                            <div class="dont-chart-title">{{chart.title}}</div>
                          </div>
                        }
                      </div>
                    </kendo-window>
                  }

                  @if (_editFormActive) {
                    <kendo-window
                      title="{{ _isCustomfieldsFormValue ? 'Add Custom Fields' : (_isAddTabFormValue ? 'Add New Tabs' : (_isRenameFormValue ? 'Edit Record' : '')) }}"
                      (close)="_closeCustomFields()"
                      class="customFieldsWindow">
                      <asap-custom-fields [accounts]="_selectedAccountIds"
                        [tabGroup]="_selectedTabId"
                        [labelId]="_selectedLabelId"
                        [labelObjectCode]="_selectedLabelObjectCode"
                        [formName]="'stock'"
                        page="building"
                        [isCustomfieldsForm]="_isCustomfieldsFormValue"
                        [isCustomtabsForm]="_isAddTabFormValue"
                        [isRenameForm]="_isRenameFormValue"
                        [language]="_language"
                        [isRenameCustomForm]="_isRenameCustomFormValue"
                        [isRenameLabel]="_isRenameLabel"
                        [isMandatory]="_isMandatory"
                        (closePopup)="ClosePopup($event)"
                        [permissionScope]="_permissionScope">
                      </asap-custom-fields>
                    </kendo-window>
                  }

                  @if (_orderingTabsForm) {
                    <kendo-window
                      title="Tab Reordering"
                      (keydown.enter)="$event.preventDefault()"
                      (close)="_closeOrderingTabsForm()">
                      <div class="row no_row_margin margin-top-30">
                        @if (false) {
                          <div class="col-12 margin-top-10">
                            <div class="form-group">
                              <label for="itemType" class="control-label">Tab 1</label>
                              <kendo-combobox [data]="_dataTabsSelected"
                                [suggest]="true"
                                [textField]="'name'"
                                [valueField]="'name'"
                                placeholder="Accounts/Sites"
                                class="newFormControlWidth disabled">
                              </kendo-combobox>
                            </div>
                          </div>
                        }
                        @for (item of _dataTabs ; track item; let i = $index) {
                          <div class="col-12 margin-top-10">
                            <div class="form-group">
                              <label for="itemType" class="control-label">Tab {{ i + 1 }}</label>
                              <kendo-combobox [data]="_dataTabsSelected"
                                [suggest]="true"
                                [textField]="'name'"
                                [valueField]="'name'"
                                [placeholder]="item.name"
                                required
                                class="bordered newFormControlWidth"
                                (valueChange)="_comboValueChange($event,i)">
                              </kendo-combobox>
                            </div>
                          </div>
                        }
                      </div>
                      <div class="row no_row_margin">
                        <div class="col-12">
                          <button kendoButton class="steps_buttons_class" (click)="_onSaveTabOrdering()">
                            <img class="backimage" [src]="'/assets/menu/'+ _theme +'/save-icon-group.svg'" />
                            <span>save & Close</span>
                          </button>
                        </div>
                      </div>
                    </kendo-window>
                  }

                  @if (_deactivatedFieldsForm) {
                    <kendo-window
                      title="Deactivated Fields"
                      (close)="_closeInactiveFields()">
                      <div class="row no_row_margin margin-top-30">
                        <div class="col-12 margin-top-10">
                          <kendo-grid [data]="_deactivatedFieldsGridData" [scrollable]="'none'">
                            <kendo-grid-column field="name" title="Fields Name">
                            </kendo-grid-column>
                            <kendo-grid-column field="formTab.name" title="Tab Name">
                            </kendo-grid-column>
                            <kendo-grid-column field="createdOn" title="Added Date" type="date">
                              <ng-template kendoGridCellTemplate let-dataItem>
                                {{dataItem.createdOn | dateFormat}}
                              </ng-template>
                            </kendo-grid-column>
                            <kendo-grid-column field="lastUpdatedOn"
                              title="Deactivation Date"
                              type="date">
                              <ng-template kendoGridCellTemplate let-dataItem>
                                {{dataItem.lastUpdatedOn | dateFormat}}
                              </ng-template>
                            </kendo-grid-column>
                            <kendo-grid-column field="Command" title="Command">
                              <ng-template kendoGridCellTemplate let-dataItem>
                                <div class="action-button action-button-deactivate"
                                  (click)="_reactivate(dataItem)">
                                  <div class="action-button-icon">
                                    <img src="/assets/menu/enterprise/deactivate-icon.svg" />
                                  </div>
                                  <div class="edit-icon-text">Reactivate</div>
                                </div>
                              </ng-template>
                            </kendo-grid-column>
                          </kendo-grid>
                        </div>
                      </div>
                    </kendo-window>
                  }

                  @if (isOpenStockItemForm) {
                    <kendo-window
                      title="Building"
                      (keydown.enter)="$event.preventDefault()"
                      (close)="OnCloseStockItemForm()"
                      class="fullWidthFormForm">
                      <!-- <div class="col-12">
                      <div class="asap-section-container zero-padding">
                        <div class="row zeromarginRow">
                          <div class="col-12 zeroPaddingColumn">
                            <div class="header-section-gray">
                              Building - GraphX
                              <span
                                [ngClass]="isStockItemChartExpanded == true ? 'k-icon k-i-sort-asc-sm' :  'k-icon k-i-sort-desc-sm'"
                                class="float-right pointer-click mt-2 mr-2"
                                (click)="ExpandCollapseStockItemChart(isStockItemChartExpanded)"
                              ></span>
                            </div>
                          </div>
                        </div>
                        <div *ngIf="isStockItemChartExpanded" class="graph-container-display">
                          <apx-chart
                            [title]="buildingChart.title"
                            [series]="buildingChart.series"
                            [chart]="buildingChart.chart"
                            [xaxis]="buildingChart.xaxis"
                            [stroke]="buildingChart.stroke"
                            [dataLabels]="buildingChart.dataLabels"
                          ></apx-chart>
                        </div>
                      </div>
                      <div class="asap-section-container zero-padding">
                        <div class="row zeromarginRow">
                          <div class="col-12 zeroPaddingColumn">
                            <div class="header-section-gray">
                              Building - Grid
                              <span
                                [ngClass]="isStockItemGridExpanded == true ? 'k-icon k-i-sort-asc-sm' :  'k-icon k-i-sort-desc-sm'"
                                class="float-right pointer-click mt-2 mr-2"
                                (click)="ExpandCollapseStockItemGrid(isStockItemGridExpanded)"
                              ></span>
                            </div>
                          </div>
                          <div *ngIf="isStockItemGridExpanded" class="col-12 zeroPaddingColumn">
                            <div class="col-12 mt-1 mb-2 chart-code-description">
                              <span>Building </span>
                            </div>
                            <asap-grid-layout
                              *ngIf="_stockItemGridColumns"
                              [page]="'stockItems'"
                              [pagingEnabled]="false"
                              [sortingEnabled]="true"
                              [filteringEnable]="true"
                              [headerEnable]="true"
                              [importEnable]="true"
                              [exportExcelEnable]="true"
                              [exportPDFEnable]="true"
                              [orderEnable]="true"
                              [headerTitle]="'Stock item'"
                              [enableSiteSelection]="false"
                              [resolver]="_getStockItemByLocationType"
                              class="ListGrid"
                              [refreshInitData]="true"
                              [withHeader]="false"
                              >
                              <ng-container *ngFor="let column of _stockItemGridColumns">
                                <ng-container *ngIf="column.selected">
                                  <ng-container
                                    *ngIf="column.isTemplate && (column.field != 'quantityPerAccount')"
                                    >
                                    <ng-template
                                      pageListColumn
                                      [field]="column.field"
                                      [name]="column.gridFieldText ? column.gridFieldText.currentText : column.title"
                                      [type]="column.type"
                                      let-item
                                      >
                                      <ng-container
                                        *ngIf="column.field == 'inventoryUnitOfMeasure.code'"
                                        >
                                        {{item.inventoryUnitOfMeasure?.code}}
                                      </ng-container>
                                      <ng-container
                                        *ngIf="column.field == 'inventoryUnitOfMeasure.unitName'"
                                        >
                                        {{item.inventoryUnitOfMeasure?.unitName}}
                                      </ng-container>
                                      <ng-container
                                        *ngIf="column.field == 'receiveUnitOfMeasure.code'"
                                        >
                                        {{item.receiveUnitOfMeasure?.code}}
                                      </ng-container>
                                      <ng-container
                                        *ngIf="column.field == 'receiveUnitOfMeasure.unitName'"
                                        >
                                        {{item.receiveUnitOfMeasure?.unitName}}
                                      </ng-container>
                                      <ng-container
                                        *ngIf="column.field == 'issueUnitOfMeasure.code'"
                                        >
                                        {{item.issueUnitOfMeasure?.code}}
                                      </ng-container>
                                      <ng-container
                                        *ngIf="column.field == 'issueUnitOfMeasure.unitName'"
                                        >
                                        {{item.issueUnitOfMeasure?.unitName}}
                                      </ng-container>
                                      <ng-container *ngIf="column.field == 'itemType.name'">
                                        {{item.itemType?.name}}
                                      </ng-container>
                                      <ng-container *ngIf="column.field == 'category.id'">
                                        {{item.category?.id}}
                                      </ng-container>
                                      <ng-container
                                        *ngIf="column.field == 'category.description'"
                                        >
                                        {{item.category?.description}}
                                      </ng-container>
                                      <ng-container *ngIf="column.field == 'costType.code'">
                                        {{item.costType?.code}}
                                      </ng-container>
                                      <ng-container *ngIf="column.field == 'costInfo.cost'">
                                        {{item.costInfo?.cost | costFormat}}
                                      </ng-container>
                                      <ng-container
                                        *ngIf="column.field == 'costInfo.markupPercent'"
                                        >
                                        {{item.costInfo?.markupPercent | costFormat}}
                                      </ng-container>
                                      <ng-container
                                        *ngIf="column.field == 'costInfo.markupNumber'"
                                        >
                                        {{item.costInfo?.markupNumber | costFormat}}
                                      </ng-container>
                                      <ng-container
                                        *ngIf="column.field == 'stockItemLeads.stockitemleadtime'"
                                        >
                                        {{getStockItemLeadsString(item.stockItemLeads)}}
                                      </ng-container>
                                      <ng-container
                                        *ngIf="column.field == 'stockItemSites.site.id'"
                                        >
                                        {{getSitesString(item.stockItemSites, true)}}
                                      </ng-container>
                                      <ng-container
                                        *ngIf="column.field == 'stockItemSites.site.name'"
                                        >
                                        {{getSitesString(item.stockItemSites, false)}}
                                      </ng-container>
                                      <ng-container *ngIf="column.field == 'account'">
                                        {{getAccountsString(item.stockItemSites)}}
                                      </ng-container>
                                      <ng-container
                                        *ngIf="column.field == 'createdUser.username'"
                                        >
                                        {{item.createdUser?.username}}
                                      </ng-container>
                                      <ng-container
                                        *ngIf="column.field == 'receiveUnitOfMeasure.multiplier'"
                                        >
                                        {{item.receiveUnitOfMeasure?.multiplier}}
                                      </ng-container>
                                      <ng-container
                                        *ngIf="column.field == 'inventoryUnitOfMeasure.multiplier'"
                                        >
                                        {{item.inventoryUnitOfMeasure?.multiplier}}
                                      </ng-container>
                                      <ng-container
                                        *ngIf="column.field == 'defaultLocation.description'"
                                        >
                                        {{item.defaultLocation?.description}}
                                      </ng-container>
                                      <ng-container
                                        *ngIf="column.field == 'category.categoryFiles'"
                                        >
                                        {{item.category?.categoryFiles ?
                                        getCategoryImage(item.category?.categoryFiles) : null}}
                                      </ng-container>
                                      <ng-container *ngIf="column.field == 'stockItemFiles.file'">
                                        {{getStockImage(item.stockItemFiles)}}
                                      </ng-container>
                                      <ng-container *ngIf="column.field == 'stockItemVendors'">
                                        {{item.stockItemVendors ?
                                        getVendors(item.stockItemVendors) : null}}
                                      </ng-container>
                                      <ng-container
                                        *ngIf="column.field == 'stockItemLeads.stockItemLeadid'"
                                        >
                                        {{getTimeUnitCode(item.stockItemLeads)}}
                                      </ng-container>
                                      <ng-container
                                        *ngIf="column.field == 'stockItemLeads.stockitemleadinterval'"
                                        >
                                        {{getTimeUnit(item.stockItemLeads)}}
                                      </ng-container>
                                      <ng-container *ngIf="column.field == 'isShopping'">
                                        {{item.isShopping}}
                                      </ng-container>
                                    </ng-template>
                                  </ng-container>
                                  <ng-container *ngIf="!column.isTemplate">
                                    <ng-template
                                      pageListColumn
                                      [field]="column.field"
                                      [name]="column.gridFieldText ? column.gridFieldText.currentText : column.title"
                                      [type]="column.type"
                                      let-item
                                      >
                                      <ng-container *ngIf="column.type == 'date'">
                                        {{ item[column.field] | dateFormat }}
                                      </ng-container>
                                      <ng-container *ngIf="column.type != 'date'">
                                        {{item[column.field]}}
                                      </ng-container>
                                      <ng-container
                                        *ngIf="column.field == 'costInfo.fixedUnitPrice'"
                                        >
                                        {{item.costInfo?.fixedUnitPrice | costFormat}}
                                      </ng-container>
                                      <ng-container *ngIf="column.field == 'costInfo.cost'">
                                        {{item.costInfo?.cost | costFormat}}
                                      </ng-container>
                                    </ng-template>
                                  </ng-container>
                                </ng-container>
                              </ng-container>
                            </asap-grid-layout>
                          </div>
                        </div>
                      </div>
                    </div> -->
                    <div class="col-12 margin-top-10">
                      <button kendoButton
                        class="steps_buttons_class"
                        (click)="OnCloseStockItemForm()">
                        <img class="backimage"
                          [src]="'/assets/menu/'+ _theme +'/close-schedule-report-icon-green.svg'" />
                          <span>close</span>
                        </button>
                      </div>
                    </kendo-window>
                  }



                  @if (_isEditForms) {
                    <asap-edit-forms
                      (close)="_onCloseEditForms($event)"
                      (saved)="_closeCustomFields()"
                      [page]="_page"
                      [permissionScope]="_permissionScope">
                    </asap-edit-forms>
                  }
